//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { EventBus } from '../../EventBus/EventBus.js'
import { axiosPost } from '../../axios/axios.js'
import { formatTime } from '../../components/helpers.js'
import { bussinessProcessObjectInitialization } from '../../components/BusinessProcess/bussinessProcessObjectInitialization.js'
import BussinessProcessButtons from '../../components/BusinessProcess/BussinessProcessButtons.vue'
import BussinessProcessButton from '../../components/BusinessProcess/BussinessProcessButton.vue'
import BusinessProcessMessages from '../../components/BusinessProcess/BusinessProcessMessages.vue'
import TableCellAlarm from '../../components/Table/TableCellAlarm.vue'
import CardPropertyObjectCustom from '../../components/Card/CardPropertyObjectCustom.vue'
import StockInventoryTaskBody from './StockInventoryTaskBody.vue'

export const REQUEST_PROPERTIES = {
  createTime: () => ({ label: 'Дата/время создания заявки', type: 'datetime' }),
  applicant: () => ({ label: 'Заявитель', type: 'object' }),

  startTimeRequired: () => ({
    label: 'Требуемое время начала инвентаризации',
    type: 'datetime'
  }),
  endTimeRequired: () => ({
    label: 'Требуемое время завершения инвентаризации',
    type: 'datetime',
    additionalValidateFn: function (val) {
      return this.request.endTimeRequired ? this.request.endTimeRequired > this.request.startTimeRequired : true
    },
    getAdditionalValidateMessage: function () {
      return `«${this.label}» должно быть больше, чем «${this.requestProperties.startTimeRequired.label}»`
    }
  }),
  prolongationAllowed: () => ({ label: 'Продление разрешено', type: 'boolean' }),
  prolongationInterval: () => ({ label: 'Время продления (часы)', type: 'number' }),
  prolongationMaxCount: () => ({ label: 'Максимальной число продлений', type: 'number' }),

  startTimeActual: () => ({
    label: 'Фактическое время начала инвентаризации',
    type: 'datetime'
  }),
  endTimeActual: () => ({
    label: 'Фактическое время завершения инвентаризации',
    type: 'datetime',
    additionalValidateFn: function (val) {
      return this.request.endTimeActual ? this.request.endTimeActual >= this.request.startTimeActual : true
    },
    getAdditionalValidateMessage: function () {
      return `«${this.label}» не может быть меньше, чем «${this.requestProperties.startTimeActual.label}»`
    }
  }),
  endTimeOverdue: () => ({ label: 'Срок нарушен', type: 'boolean' }),
  prolongationIntervalActual: () => ({ label: 'Время продления', type: 'number' }),

  stock: () => ({ label: 'Склад', type: 'object' }),
  inventoryCompleteness: () => ({ label: 'Полнота инвентаризации', type: 'object' }),
  actualizeAfterStart: () => ({ label: 'Актуализировать номенклатурные позиции после начала инвентаризации', type: 'boolean' }),
  partialExecutionAllowed: () => ({ label: 'Разрешено частичное выполнение', type: 'boolean' }),
  earlyExecutionAllowed: () => ({ label: 'Разрешено досрочное выполнение', type: 'boolean' }),
  executor: () => ({ label: 'Исполнитель', type: 'object' }),

  withdrawnToolRecordsPresent: () => ({ label: 'Частичный отзыв результатов', type: 'boolean' }),

  toolRecords: () => ({
    label: 'Номенклатурные позиции',
    type: 'table',
    subType: 'toolRecords',
    convertItemToServer: function (item) {
      const itemToServer = {}
      itemToServer.id = item.id
      itemToServer.toolId = item.tool && item.tool.id || null
      itemToServer.uniqueKey = item.tool && item.tool.uniqueKey || null
      if (!itemToServer.toolId) {
        itemToServer.unknown = true
        itemToServer.unit = item.unit || null
        itemToServer.toolName = item.tool && item.tool.name || null
        itemToServer.serialNumber = item.tool && item.tool.serialNumber || null
        itemToServer.inventoryNumber = item.tool && item.tool.inventoryNumber || null
      }
      itemToServer.amountReal = item.amountReal
      itemToServer.photosIds = item.photos != null && item.photos.length ? item.photos.map(file => file.id || file) : null
      itemToServer.additional = item.additional
      itemToServer.regrading = item.regrading
      itemToServer.changeTime = item.changeTime
      itemToServer.withdrawTime = item.withdrawTime
      itemToServer.surplusTransferTime = item.surplusTransferTime
      itemToServer.surplusTransferPhotos = item.surplusTransferPhotos != null && item.surplusTransferPhotos.length ? item.surplusTransferPhotos.map(file => file.id || file) : null
      itemToServer.surplusTransferConfirmationTime = item.surplusTransferConfirmationTime

      return itemToServer
    }
  }),
  regradingRecords: () => ({
    label: 'Пересортица',
    type: 'table',
    subType: 'regardingRecords',
    convertItemToServer: function (item) {
      const itemToServer = {}
      itemToServer.id = item.id
      itemToServer.toolAId = item.toolA && item.toolA.id || null
      itemToServer.toolAUniqueKey = item.toolA && item.toolA.uniqueKey || null
      itemToServer.toolARecordId = item.toolARecordId || null
      itemToServer.toolBId = item.toolB && item.toolB.id || null
      itemToServer.toolBUniqueKey = item.toolB && item.toolB.uniqueKey || null
      itemToServer.toolBRecordId = item.toolBRecordId || null
      itemToServer.amountDiff = item.amountDiff
      itemToServer.amountDiffType = item.amountDiffType && item.amountDiffType.id || null
      itemToServer.regradingType = item.regradingType && item.regradingType.id || null
      return itemToServer
    }
  }),

  comments: () => ({ label: 'Комментарии', type: 'table' })
}

const EVENTS_PROPERTIES = {
  executorAssigned: () => ({
    executor: {
      type: 'object',
      label: 'Исполнитель',
      subType: 'employee',
      // subSubType: 'forkLiftDriver',
      component: CardPropertyObjectCustom,
      componentProps: {
        singleModelObject: true,
        select: false,

        fullReadable: false,
        searchable: true,
        searchValueMinLength: 0,
        searchFiltrationBySource: true,
        cached: false,
        proxy: {
          urlBase: '/service/delta/stockInventory/task/propertyValues',
          searchParamKey: 'searchPattern',
          get urlParams () {
            const params = {}
            params.property = 'executor'
            return params
          },
          filterType: 'stockInventoryExecutor',
          formId: 'stockInventoryTask'
        },

        dialogLabel: 'Выбор исполнителя',
        dialogColumns: [
          {
            name: 'name',
            label: 'ФИО',
            align: 'left',
            field: row => row.name,
            sortable: true,
            columnFormat: 'object',
            columnObjectType: 'employee'
          },
          {
            name: 'position',
            label: 'Должность',
            align: 'left',
            field: 'position',
            sortable: false
          },
          {
            name: 'department',
            label: 'Отдел',
            align: 'left',
            field: 'department',
            sortable: false
          },
          {
            name: 'workAreas',
            label: 'Направление работ',
            align: 'left',
            field: 'workAreas',
            format: workAreas => workAreas != null ? workAreas.join(', ') : '',
            sortable: false
          }
        ]
      }
    }
  }),
  prolong: () => ({
    interval: {
      type: 'duration',
      // format: 'HH:mm:ss',
      label: 'Время продления (интервал)',
      getDefaultValueFn: function () {
        const request = this._record.request
        return request.prolongationInterval || null
      }
    },
    endTime: {
      type: 'datetime',
      label: 'Требуемое время завершения (продленное)',
      getDefaultValueFn: function () {
        const request = this._record.request
        if (request.endTimeRequired && request.prolongationInterval) {
          return request.endTimeRequired + request.prolongationInterval
        }
        return null
      }
    }
  }),
  notApprovedReportsDebitsRequest: () => ({
    requestReports: {
      type: 'objects',
      label: 'Отчёты для утверждения списаний',
      subType: 'requestReport',
      component: CardPropertyObjectCustom,
      componentProps: {
        multiple: true,
        readonly: true
      }
    }
  }),
  reportReady: () => ({
    partialExecution: {
      label: 'Частичное выполнение',
      type: 'boolean'
    },
    reason: {
      label: 'Причина невыполнения плана',
      type: 'string'
    }
  }),
  synchronizationResponse: () => ({
    externalResultState: {
      label: 'Статус результата в 1С',
      type: 'listvalue',
      listvalues: [
        { value: 'withdrawn', name: 'Отозван' },
        { value: 'counting', name: 'Пересчет' },
        { value: 'approved', name: 'Утвержден' }
      ]
    },
    externalResultClosed: {
      label: 'Результат закрыт в 1С',
      type: 'boolean'
    },
    externalSynchronizationStatus: {
      label: 'Статус синхронизации с 1С',
      type: 'listvalue',
      listvalues: [
        { value: 'success', name: 'Успешное выполнение синхронизации' },
        { value: 'error', name: 'Ошибка синхронизации' }
      ]
    },
    externalSynchronizationErrorType: {
      label: 'Ошибка синхронизации с 1С',
      type: 'listvalue',
      listvalues: [
        { value: 'connection', name: 'Ошибка связи' },
        { value: 'amountMismatch', name: 'Несовпадение учетных значений' },
        { value: 'stockNegativeAmount', name: 'Отрицательные остатки на складе' },
        { value: 'correctionStockNegativeAmount', name: 'Отрицательные остатки на коррекционном складе' },
        { value: 'unknownCorrectionStock', name: 'Не указан коррекционный склад' },
        { value: 'resultClosed', name: 'Результат закрыт' }
      ]
    },
    externalSynchronizationErrorMessage: {
      label: 'Сообщение об ошибке',
      type: 'string'
    },
    attemptCount: {
      type: 'number',
      label: 'Количество попыток'
    },
    lastAttemptTime: {
      type: 'datetime',
      label: 'Время последней попытки'
    }
  }),
  reason: () => ({
    reason: {
      type: 'string',
      label: 'Причина'
    }
  }),
  confirmation: () => ({
  })
}

export default {
  components: {
    BussinessProcessButtons,
    BussinessProcessButton,
    BusinessProcessMessages,
    StockInventoryTaskBody,
    TableCellAlarm
  },
  mixins: [bussinessProcessObjectInitialization],
  props: {
    inputAdditionalParams: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      bussinessProcessConfiguration: {
        REQUEST_PROPERTIES: REQUEST_PROPERTIES,
        EVENTS_PROPERTIES: EVENTS_PROPERTIES,
        businessProcessKey: 'stockInventoryRequest',
        serviceSubPath: 'stockInventory/task'
      },

      record: {
        bp: {},
        actions: [],
        request: {},
        requestInitial: {}, // ui
        requestForm: {},

        requestProperties: null
      },

      formatTime: formatTime,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    access: function () {
      return this.user.hasRole('admin')
    },
    stateInfo: function () {
      const record = this.record
      if (record && record.request.id && record.request.id !== -1 && record.bp && record.bp.stateInfo) {
        const stateInfo = JSON.parse(JSON.stringify(record.bp.stateInfo))
        if (!stateInfo.color) {
          stateInfo.color = '#027BE3' // primary
        }
        return stateInfo
      }
      return null
    },
    buttonSave: function () {
      return this.record.actions.find(action => action.id === 'save')
    },
    notApprovedDebits: function () {
      return this.record && this.record.bp && this.record.bp.notApprovedDebits || {}
    },
    bpMessages: function () {
      return this.record && this.record.bp && this.record.bp.messages || []
    }
  },
  watch: {
    '$route.params.id': {
      handler: async function (value) {
        if (value !== 'create') {
          if (value != null) {
            this.loadStockInventoryTask(value, this.inputAdditionalParams)
          }
        } else {
          this.loadStockInventoryTask(-1, this.inputAdditionalParams)
        }
      },
      immediate: true
    }
  },
  methods: {
    onClose: function () {
      EventBus.$emit('delete-tools-from-storage', {})

      if (window.history.length != 1 && window.history.state !== null) {
        this.$router.back()
      } else {
        this.$router.push('/')
      }
    },
    onValidate: function (validFieldKeys) {
      if (this.$refs.stockInventoryTaskBody) {
        this.$refs.stockInventoryTaskBody.validate(validFieldKeys)
      }
    },
    loadStockInventoryTask: function (id = this.record.request.id, additionalParams = null, clearStorage = false) {
      if (id !== -1 && this.$route.params.id === 'create') {
        this.$router.replace({ name: 'stockInventoryTask', params: { id: id } })
      }

      if (clearStorage) {
        EventBus.$emit('delete-tools-from-storage', {})
      }

      return this.load(id, additionalParams)
    },
    onSave: function () {
      const saveBtn = this.$refs.saveBtn
      if (saveBtn) {
        saveBtn.onClickButton(this.buttonSave)
      }
    },
    onSendNotApprovedDebitsRequest: function () {
      this.loading = true
      const bodyFormData = new FormData()
      bodyFormData.set('id', this.record.request.id)

      axiosPost({
        url: '/service/delta/stockInventory/task/sendNotApprovedDebitsRequest',
        data: bodyFormData,
        onSuccess: (response) => {
          this.notApprovedDebits.requestSent = true
        },
        onFailure: 'Ошибка отправки запроса на утверждение списаний'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
